import { Col, Container, Row } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { useQuery } from "react-query";

import Loader from "./Loader";
import wpPageQuery from "./wpPageQuery";

const WPPage = () => {
	const { pathname } = useLocation();
	const navigate = useNavigate();

	const {
		isError,
		isLoading,
		data
	} = wpPageQuery(
		useQuery,
		pathname,
		{
			onError: () => {
				navigate("/");
			},
			retry: false
		}
	);

	return isLoading
		? <Loader />
		: isError
			? <div>Page Not Found</div>
			: (
				<Row className="flew-nowrap">
					<Col className="px-0" id="main">
						<Container as="main" className="px-5 py-5" id="content">
							<h1>{data?.title}</h1>
							<div className="page-content" dangerouslySetInnerHTML={{ __html: data?.content }} />
						</Container>
					</Col>
				</Row>
			);
};

export default WPPage;
